import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import TemplateContainer from "../../common/TemplateContainer";
import FaqCountSelector from "./FaqCountSelector";
import FaqFormatSelector from "./FaqFormatSelector";

const Faq = () => {
  const { values } = useFormikContext<Partial<Template>>();

  const includeFaq = Boolean(values?.includeFaq);
  if (!includeFaq) return null;

  return (
    <div className="space-y-6 animate-fadeIn">
      <TemplateContainer>
        <FaqFormatSelector />
        <FaqCountSelector />
      </TemplateContainer>
    </div>
  );
};

export default Faq;
